<template lang="pug">
  #doneTmpOrder
    #done-tmp-container.text-center.pt-5
      b-card.body-width.mx-auto.mb-5(body-class="px-5")
        .card-box.mx-auto
          p.mt-3.text-left.white-space {{text_content}}
          b-table-simple.my-4.rounded(responsive="responsive", bordered)
            b-tbody
              b-tr
                b-th.alert-secondary.mail_label {{mail_label}}
                b-td.text-left(data-testid="done_tmp_mail_address") {{mail_address}}
          p.text-left.white-space.text_caution {{text_caution}}
</template>

<script>
export default {
  name: "doneTmpOrder",
  props: {
    p_mail_address: { type: String, required: true},
  },
  data() {
    return {
      text_content: "下記のメールアドレスへ本登録お申込みフォームURLを記載した\n"
          + "件名「【desknet's NEO/ChatLuck クラウド版】お申し込み画面へのご案内」\n"
          + "メールを送信いたしました。",
      text_caution: "※メールに記載されている「本登録お申込みフォームURL」をクリックしていただくことで、\n"
          + "　登録完了となります。\n"
          + "※メール送信後、24時間を超過しますと、セキュリティ保持のため有効期限切れとなります。\n"
          + "　その場合は再度、最初からお手続きをお願いいたします。",
      mail_label: "メールアドレス",
      mail_address: this.p_mail_address,
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.card-box {
  max-width: 600px;
}
p {
  font-size: 15px;
}
.white-space {
  white-space: pre-wrap;
}
.mail_label {
  width: 200px;
  white-space: nowrap;
}
.text_caution {
  font-size: smaller;
  color: red;
}
</style>